import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenService } from 'sce-core';
import { UserService } from 'sce-core';

@Injectable()
export class AlwaysAuthChildrenGuard implements CanActivateChild {

  constructor(private tokenService: TokenService,
    private userService: UserService,
    private router: Router) { }

  public canActivateChild(route: ActivatedRouteSnapshot) {
    if (this.tokenService.isAuthenticatedUser()) {
      return true;
    } else {
      // Clear any existing data by calling logout();
      this.userService.logout();
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/guards/always-auth-children.guard.ts